import React, { Component } from 'react';
import PopupMenu from './PopupMenu';

class DropdownMenu extends Component {
    state = { anchorEl: null };
    _toggleOpenClose = event => this.setState({ anchorEl: this.state.anchorEl ? null : event.currentTarget });
    _handleClose = () => this.setState({ anchorEl: null });
    _select = (value, index) => {
        if (!this.props.disabled[index]) {
            this._handleClose();
            this.props.selectFunctions[index] && this.props.selectFunctions[index]();
        }
    };
    render() {
        return (
            <div className="ckp-dropdown-menu">
                <label className="ckp-dropdown-menu-label" onClick={this._toggleOpenClose}>
                    {this.props.label}
                </label>
                <PopupMenu
                    minWidth={100}
                    options={this.props.options}
                    disabled={this.props.disabled}
                    onClose={this._handleClose}
                    anchorElement={this.state.anchorEl}
                    onOptionSelected={this._select}
                    selected={false}
                />
            </div>
        );
    }
}

DropdownMenu.defaultProps = {
    disabled: [],
    selectFunctions: []
};

export default DropdownMenu;
